import React, { useState, useEffect } from "react";
import {
  message,
  Space,
  Row,
  // Typography,
} from "antd";
import { Typography, Button, Box } from "@mui/material";
import "../../../style/sample.css";
import TransactionDrawer from "./completedDrawer";
import TransactionTableFilters from "./transactionTableFilters";
import { backendPatchWithoutRefresh, backendPostWithoutRefresh } from "../../../helpers/callBackend";
import GenericTableOnRowOnClick from "../../tables/genericTableOnRowOnClick";
import GenericTableOnRowOnClick1 from "../../tables/genericTableOnRowOnClick1";
import SplitPaymentModal from "../card/splitPaymentModal";
import CheckImageView from "../card/checkImageView";
import CurrencySingleValue from "../currency/singleValue";
import GenericDropdown from "../../generic/genericDropdown";
import { getEditedTxns, getNeedsReviewTxns, getOriginalTxns, needsReviewCount, transactionsKindChangeHelper } from "../../../helpers/transactions/filters";
import moment from "moment";
import TitledSection from "../../generic/titledSection";
import PaymentRequestsActions from "../paymentRequests/PaymentRequestsActions";
import PaymentRequestDropDown from "../paymentRequests/PaymentRequestDropDown";
import { useUcs } from "../../../helpers/contexts/UserCompanySettingsContext";

function CompleteTransactions(props) {
  const [completeTransactions, setCompleteTransactions] = useState(props.completeTransactions.map((txn) => ({ ...txn, key: txn.id })));
  const [pendingTransactions, setPendingTransactions] = useState(props.pendingTransactions);
  const [dateRangeFilter, setDateRangeFilter] = useState(null);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showCompletedTxns, setShowCompletedTxns] = useState(props.completeTransactions.map((txn) => ({ ...txn, key: txn.id })).filter((txn) => txn.is_original));
  const [showPendingTxns, setShowPendingTxns] = useState(props.pendingTransactions);
  const [showSplitPaymentModal, setShowSplitPaymentModal] = useState(false);
  const [transactionsKind, setTransactionsKind] = useState("Original");
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [showPendingTable, setShowPendingTable] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [paymentRequests, setPaymentRequests] = useState(props.paymentRequests);
  const [showPaymentRequests, setShowPaymentRequests] = useState(false)
  const [isDashboardEditor, setIsDashboardEditor] = useState(false)
  const ucsContext = useUcs()

  useEffect(() => {
    if (ucsContext.loaded) {
      setIsDashboardEditor(ucsContext.isDashboardEditor())
    }
  }, [ucsContext])

  const handleExpand = (expanded, record) => {
    if (expanded) {
      setSelectedTransaction(record);
      setExpandedRowKeys([record.id]);
    } else {
      setExpandedRowKeys([]);
    }
  };

  useEffect(() => {
    if (!props.paymentRequests) {
      return
    }
    setPaymentRequests(props.paymentRequests)
    setShowPaymentRequests(props.paymentRequests.length > 0)
  }, [props.paymentRequests])

  useEffect(() => {
    let updatedCompleteTransactions = props.completeTransactions.map(transaction => {
      if (transaction.transaction_code === "" || transaction.transaction_code === null) {
        const prefixId = transaction.id.split('_')[0] + '_' + transaction.id.split('_')[1];
        const prefixObject = props.completeTransactions.find(obj => obj.id === prefixId);
        if (prefixObject) {
          return {
            ...transaction,
            transaction_code: prefixObject.transaction_code,
            key: transaction.id
          };
        }
      }
      return { ...transaction, key: transaction.id };
    });
    setCompleteTransactions(updatedCompleteTransactions);
    const newShowTransactions = updatedCompleteTransactions.filter((txn) => txn.is_trash === false)
    if (transactionsKind === "Original") {
      setShowCompletedTxns(getOriginalTxns(newShowTransactions));
    } else if (transactionsKind === "Edited") {
      setShowCompletedTxns(getEditedTxns(newShowTransactions));
    } else if (transactionsKind === "Needs Review") {
      setShowCompletedTxns(getNeedsReviewTxns(newShowTransactions));
    }
  }, [props.completeTransactions]);

  useEffect(() => {
    if (props.pendingTransactions === undefined) return
    setPendingTransactions(props.pendingTransactions);
    setShowPendingTxns(props.pendingTransactions);
    setShowPendingTable(props.pendingTransactions.length > 0)
  }, [props.pendingTransactions]);

  const handleSearch = (e) => {
    const currentToggleTransactions = handleFilters(transactionsKind);
    if (e.target.value === "") {
      setShowCompletedTxns(currentToggleTransactions);
      setShowPendingTxns(props.pendingTransactions);
    } else {
      let searchText = e.target.value.toLowerCase();
      let dataCompleted = [...currentToggleTransactions];
      let dataPending = [...props.pendingTransactions];
      let resDataCompleted = [];
      let resDataPending = [];
      let isExclusion = false;
      if (searchText.startsWith("!")) {
        isExclusion = true;
        searchText = searchText.substring(1);
      }
      for (let i = 0; i < dataCompleted.length; i++) {
        const prop_name1 = dataCompleted[i].description || "";
        const prop_name2 = dataCompleted[i].timestamp || "";
        const prop_name3 = dataCompleted[i].transaction_code || "";
        const prop_name4 = dataCompleted[i].counterparty_name || "";
        const matchesSearch = (
          prop_name1.toLowerCase().includes(searchText) ||
          prop_name2.toLowerCase().includes(searchText) ||
          prop_name3.toLowerCase().includes(searchText) ||
          prop_name4.toLowerCase().includes(searchText)
        );
        if ((isExclusion && !matchesSearch) || (!isExclusion && matchesSearch)) {
          resDataCompleted.push(dataCompleted[i]);
        }
      }
      for (let i = 0; i < dataPending.length; i++) {
        const prop_name1 = dataPending[i].attributes?.counterparty?.name || "";
        const prop_name2 = dataPending[i].attributes?.description || "";
        const prop_name3 = dataPending[i].type || "";
        const matchesSearch = (
          prop_name1.toLowerCase().includes(searchText) ||
          prop_name2.toLowerCase().includes(searchText) ||
          prop_name3.toLowerCase().includes(searchText)
        );
        if ((isExclusion && !matchesSearch) || (!isExclusion && matchesSearch)) {
          resDataPending.push(dataPending[i]);
        }
      }
      setShowCompletedTxns(resDataCompleted);
      setShowPendingTxns(resDataPending);
    }
  };

  const handleDateFilter = (value) => {
    const currentToggleTransactions = handleFilters(transactionsKind);
    if (value && value.length === 2) {
      setDateRangeFilter(value);
      var start_date = value[0].format("YYYY-MM-DD");
      var end_date = value[1].format("YYYY-MM-DD");
      var data = [...currentToggleTransactions];
      var resData = [];
      for (var i = 0; i < data.length; i++) {
        var txn_date = data[i].timestamp.split("T")[0];
        if (txn_date >= start_date && txn_date <= end_date) {
          resData.push(data[i]);
        }
      }
      setShowCompletedTxns(resData);
      data = props.pendingTransactions;
      resData = [];
      for (i = 0; i < data.length; i++) {
        txn_date = data[i]["attributes"]['createdAt'].split(" ")[0];
        if (txn_date >= start_date && txn_date <= end_date) {
          resData.push(data[i]);
        }
      }
      setShowPendingTxns(resData);
    } else {
      setDateRangeFilter(null);
      setShowCompletedTxns(currentToggleTransactions.filter((txn) => txn.is_trash === false));
      setShowPendingTxns(props.pendingTransactions);
    }
  };

  const cancelTxn = (recordId, isCompleted = false) => {
    var data = {
      unit_payment_id: recordId,
      completed_transaction: isCompleted
    };
    backendPostWithoutRefresh("/api/transactions/cancel-transaction/", data)
      .then((response) => {
        if (response.data.description === "Transaction deleted" && isCompleted) {
          message.success("Transaction deleted", 5);
          props.cancelCompletedTransaction(recordId, () => {
            setShowCompletedTxns(props.completeTransactions.filter((txn) => txn.is_trash === false));
          })
        } else {
          props.cancelPendingTransaction(recordId, () => {
            setShowPendingTxns(props.pendingTransactions);
          });
        }
      })
  }

  const closeSplitTransactionModal = () => {
    setShowSplitPaymentModal(false);
  }

  const updateCompletedTransactions = (newTransactions, originalTxnId) => {
    setCompleteTransactions((prevState) => {
      const updatedCompleteTxns = prevState.map((txn) => {
        if (txn.id === originalTxnId) {
          return { ...txn, is_edited: true };
        }
        return txn;
      });
      return [...updatedCompleteTxns, ...newTransactions]
    })
    setShowCompletedTxns((prevState) => {
      if (transactionsKind === "Edited") {
        const updatedShowCompletedTxns = prevState.filter((txn) => {
          return txn.id !== originalTxnId
        });
        const newShowTransactions = getEditedTxns(newTransactions);
        setSelectedTransaction(newShowTransactions[0])
        return [...updatedShowCompletedTxns, ...newShowTransactions]
      } else if (transactionsKind === "Original") {
        const updatedShowCompletedTxns = prevState.map((txn) => {
          if (txn.id === originalTxnId) {
            return { ...txn, is_edited: true };
          }
          return txn;
        });
        return [...updatedShowCompletedTxns]
      }
    });
  };

  // Centralized transaction update handler
  const updateTransactionInState = (transactionId, updatedTransaction) => {
    // Update complete transactions state
    setCompleteTransactions(prevTransactions => {
      return prevTransactions.map(transaction => 
        transaction.id === transactionId ? { ...updatedTransaction, key: updatedTransaction.id } : transaction
      );
    });
    
    // Update show completed transactions state
    setShowCompletedTxns(prevTransactions => {
      return prevTransactions.map(transaction => 
        transaction.id === transactionId ? { ...updatedTransaction, key: updatedTransaction.id } : transaction
      );
    });
    
    // Update selected transaction if it's the one being edited
    setSelectedTransaction(prevSelected => {
      if (prevSelected && prevSelected.id === transactionId) {
        return updatedTransaction;
      }
      return prevSelected;
    });
    
    // Update parent component if handler exists
    if (props.updateCompletedTransaction) {
      props.updateCompletedTransaction(transactionId, updatedTransaction);
    }
  };

  const handleCounterpartyNameChange = async (counterpartyName) => {
    const transactionId = selectedTransaction.id;
    
    try {
      const res = await backendPatchWithoutRefresh("/api/transactions/", {
        id: transactionId,
        counterparty_name: counterpartyName,
      });
      
      const updatedTransaction = res.data.data;
      updateTransactionInState(transactionId, updatedTransaction);
    } catch (error) {
      console.error('Failed to update counterparty name:', error);
      message.error('Failed to update counterparty name');
    }
  };

  const handleCounterpartyAssign = async (counterpartyId) => {
    const transactionId = selectedTransaction.id;
    
    try {
      const res = await backendPatchWithoutRefresh("/api/transactions/", {
        id: transactionId,
        counterparty_id: counterpartyId,
      });
      
      const updatedTransaction = res.data.data;
      updateTransactionInState(transactionId, updatedTransaction);
    } catch (error) {
      console.error('Failed to assign counterparty:', error);
      message.error('Failed to assign counterparty');
    }
  };

  const handleDateChange = (newDate) => {
    const journalTransaction = {
      ...selectedTransaction,
      id: selectedTransaction.id + ".journal",
      description: "Journal",
      amount: -1 * selectedTransaction.amount,
      is_original: false,
      is_journal: true,
      is_manual: true,
    }
    const newTransaction = {
      ...selectedTransaction,
      id: selectedTransaction.id + ".1",
      timestamp: newDate,
      is_original: false,
      is_manual: true,
      is_journal: false,
    }
    const transactions = [journalTransaction, newTransaction];
    const data = {
      bank_account_id: props.bankAccountId,
      transactions: transactions,
      original_transaction_id: selectedTransaction.id,
    }
    backendPostWithoutRefresh("/api/transactions/", data)
      .then((response) => {
        updateCompletedTransactions(response.data.transactions, selectedTransaction.id);
      })
      .catch((error) => {
        message.error("Something went wrong");
        console.error(error);
      });
  }

  const handleNotesChange = async (newNotes) => {
    const transactionId = selectedTransaction.id;
    
    try {
      const res = await backendPatchWithoutRefresh("/api/transactions/", {
        id: transactionId,
        notes: newNotes,
      });
      
      const updatedTransaction = res.data.data;
      updateTransactionInState(transactionId, updatedTransaction);
    } catch (error) {
      console.error('Failed to update notes:', error);
      message.error('Failed to update notes');
    }
  };

  const handleEditableFieldUpdate = async (field, value) => {
    const transactionId = selectedTransaction.id;
    let params = {
      id: transactionId
    };
    params[field] = value;
    
    try {
      const patchResponse = await backendPatchWithoutRefresh("/api/transactions/", params);
      
      if (patchResponse.status === 200) {
        const updatedTransaction = patchResponse.data.data;
        updateTransactionInState(transactionId, updatedTransaction);
        return updatedTransaction;
      }
    } catch (error) {
      console.error(`Failed to update ${field}:`, error);
      message.error(`Failed to update ${field}`);
      throw error;
    }
  };

  const handleNotesSave = (row) => {
    const newData = [...showCompletedTxns];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    backendPatchWithoutRefresh("/api/transactions/", {
      id: selectedTransaction.id,
      notes: row.notes,
    }).then((res) => {
      setShowCompletedTxns(newData);
    });
  };

  const handleCustomCategoriesChange = (updatedTransaction) => {
    const transactionId = selectedTransaction.id;
    updateTransactionInState(transactionId, updatedTransaction);
  };

  const handleFilters = (transactionsKind) => {
    return transactionsKindChangeHelper({
      transactionsKind: transactionsKind,
      transactions: completeTransactions,
      calculated: false,
    });
  }

  const handleTransactionsKindChange = (transactionsKind) => {
    setTransactionsKind(transactionsKind);
    setShowCompletedTxns(handleFilters(transactionsKind));
  }

  const handleApproveEdits = (updatedTransaction) => {
    const transactionId = selectedTransaction.id;
    updateTransactionInState(transactionId, updatedTransaction);
  };

  // Generic transaction update handler for the drawer
  const handleTransactionUpdate = (updatedTransaction) => {
    updateTransactionInState(updatedTransaction.id, updatedTransaction);
  };

  const table_columns = [
    {
      field: 'timestamp',
      headerName: 'Date',
      flex: 1,
      sortable: true,
      sortComparator: (v1, v2) => new Date(v1).getTime() - new Date(v2).getTime(),
      renderCell: (params) => {
        let timestamp = params.row.timestamp;
        if (!timestamp) return null;
        return (
          <div>
            <Typography
              variant="body1"
              color="primary"
              component="span"
            >
              {timestamp.slice(0, 10)}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ fontSize: '12px', fontStyle: 'italic', paddingLeft: '10px' }}
              component="span"
            >
              {moment(timestamp).format('h:mm A')}
            </Typography>
          </div>
        )
      },
    },
    {
      field: 'counterparty_name',
      headerName: 'To/From',
      flex: 1,
      renderCell: (params) => (
        <p style={{ textTransform: 'capitalize', margin: 0 }}>
          {params.row.counterparty_name}
        </p>
      ),
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 2,
      renderCell: (params) => (
        <div>
          <div>{params.row.description}</div>
          {params.row.notes?.length > 0 && (
            <div>
              <Typography
                variant="body2"
                color="primary"
                style={{ fontSize: '12px', fontStyle: 'italic' }}
              >
                {params.row.notes}
              </Typography>
            </div>
          )}
        </div>
      ),
    },
    {
      field: 'transaction_code',
      headerName: 'Method',
      flex: 1,
      renderCell: (params) => (
        <p style={{ textTransform: 'capitalize', margin: 0 }}>
          {params?.row?.transaction_code ? params?.row?.transaction_code : ''}
        </p>
      ),
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      // align: 'right',
      renderCell: (params) => (
        <span style={{ color: '' }}>
          <CurrencySingleValue
            amount={params.row.amount}
            currency={params.row.currency}
            currencySymbol={params.row.currency_symbol}
          />
        </span>
      ),
    },
    {
      field: "balance",
      headerName: "Balance",
      flex: 1,
      renderCell: (params) => {
        if (params.row.balance == "0.00") {
          return <></>;
        }
        return (
          <span style={{ color: "" }}>
            {
              <CurrencySingleValue
                amount={params.row.balance}
                currency={params.row.currency}
                currencySymbol={params.row.currency_symbol}
              />
            }
          </span>
        )
      }
    },
    {
      field: 'action',
      headerName: '',
      flex: 0.5,
      align: 'right',
      renderCell: (params) => {
        if (!isDashboardEditor) {
          return <></>
        }
        return(
          <GenericDropdown
            dropdownItems={[
              <div
                onClick={(event) => {
                  event.stopPropagation();
                  setShowSplitPaymentModal(true);
                  setSelectedTransaction(params.row);
                }}
              >
                Split
              </div>,
            ]}
          />
        )
      },
    },
  ];



  const table_columns1 = [
    {
      field: 'createdAt',
      headerName: 'Date',
      flex: 1,
      renderCell: (params) => {
        const date = params?.row?.attributes?.createdAt;
        const formattedDate = date ? moment(date).format('YYYY-MM-DD') : 'N/A';
        return <span>{formattedDate}</span>;
      },
      valueGetter: (params) => {
        const date = params?.row?.attributes?.createdAt;
        const normalizedDate = moment(date, moment.ISO_8601, true).isValid()
          ? moment(date).toISOString() // Parse ISO or YYYY-MM-DD formats
          : moment(date, 'YYYY-MM-DD').toISOString(); // Parse already formatted dates
        return normalizedDate;
      },
      sortComparator: (v1, v2) => {
        if (!v1) return 1; // Nulls come last
        if (!v2) return -1; // Nulls come last
        return new Date(v2) - new Date(v1); // Sort in descending order
      },
    },
    {
      field: 'counterparty_name',
      headerName: 'To/From',
      flex: 1,
      renderCell: (params) => (
        params?.row?.type?.startsWith("Originated") ? (
          <p style={{ textTransform: 'capitalize' }}>
            {params?.row?.attributes?.counterparty?.name}
          </p>
        ) : (
          <p style={{ textTransform: 'capitalize' }}></p>
        )
      ),
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 2,
      renderCell: (params) => (
        <div>
          <Row style={{ textTransform: 'capitalize' }}>{params?.row?.attributes?.description}</Row>
        </div>
      ),
    },
    {
      field: 'type',
      headerName: 'Method',
      flex: 1,
      renderCell: (params) => (
        <p style={{ textTransform: 'capitalize' }}>
          {params?.row?.type}
        </p>
      ),
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      renderCell: (params) => (
        <span>
          <CurrencySingleValue
            amount={params?.row?.attributes?.amount}
            currency={params?.row?.attributes?.currency}
            currencySymbol={params?.row?.attributes?.currency_symbol}
          />
        </span>
      ),
    },
    {
      field: 'action',
      headerName: '',
      flex: 0.5,
      align: 'right',
      renderCell: (params) => {
        if (!isDashboardEditor) {
          return <></>
        }
        const record = params?.row;
        switch (record?.type) {
          case "Originated ACH Payment":
            return (
              <GenericDropdown
                dropdownItems={[
                  <div
                    style={{ color: "red", cursor: "pointer" }}
                    onClick={(event) => {
                      event.stopPropagation();
                      cancelTxn(record.id);
                    }}
                  >
                    Cancel
                  </div>,
                ]}
              />
            );
          case "Check Deposit":
            return (
              <GenericDropdown
                dropdownItems={[
                  <CheckImageView
                    record={record}
                    bankAccountId={props.bankAccountId}
                  />,
                ]}
              />
            );
          case "Check Payment":
            return (
              <GenericDropdown
                dropdownItems={[
                  <CheckImageView
                    record={record}
                    bankAccountId={props.bankAccountId}
                  />,
                ]}
              />
            );
          default:
            return null;
        }
      },
    },
  ];

  const payment_request_columns = [
    {
      field: 'created_timestamp',
      headerName: 'Date',
      flex: 1,
      renderCell: (params) => {
        const date = params?.row?.created_timestamp
        const formattedDate = date ? moment(date).format('YYYY-MM-DD') : 'N/A';
        return <span>{formattedDate}</span>;
      },
      valueGetter: (params) => {
        const date = new Date(params)
        return date.toLocaleString()
      },
      sortComparator: (v1, v2) => {
        if (!v1) return 1 // Nulls come last
        if (!v2) return -1 // Nulls come last
        return new Date(v2) - new Date(v1) // Sort in descending order
      },
    },
    {
      field: 'created_by',
      headerName: 'To/From',
      flex: 1,
      renderCell: (params) => (
        <Typography
          sx={{ textTransform: 'capitalize' }}
          variant="primary"
        >
          {params?.row?.created_by}
        </Typography>
      )
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 2,
      renderCell: (params) => (
        <Typography
          sx={{ textTransform: 'capitalize' }}
          variant="primary"
        >
          {params?.row?.description}
        </Typography>
      ),
    },
    {
      field: 'type',
      headerName: 'Method',
      flex: 1,
      renderCell: (params) => (
        <Typography variant="primary">ACH</Typography>
      ),
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      renderCell: (params) => {
        const {from_bank_account} = params.row
        // use scalar to present amount correcly based on source account
        const scalar = from_bank_account == props.bankAccountId ? -1 : 1
        return (
          <CurrencySingleValue
            amount={scalar * params?.row?.amount}
            currency="USD"
            currencySymbol={params?.row?.attributes?.currency_symbol}
          />
        )
      },
    },
    {
      field: 'actions',
      headerName: '',
      flex: 1,
      renderCell: (params) => {
        return (
          <PaymentRequestsActions
            paymentRequest={params.row}
            updatePaymentRequests={props.updatePaymentRequests}
          />
        )
      }
    },
    {
      field: 'dropdown',
      headerName: '',
      flex: 0.5,
      align: 'right',
      renderCell: (params) => {
        if (!isDashboardEditor) {
          return <></>
        }
        return(
          <PaymentRequestDropDown
            paymentRequest={params.row}
            updatePaymentRequests={props.updatePaymentRequests}
          />
        )
      }
    }
  ]

  const totalTableWidth = table_columns.reduce((totalWidth, column) => {
    return totalWidth + parseFloat(column.width || 0);
  }, 0);
  const firstColumnWidthFraction = parseFloat(table_columns[0].width || 0) / totalTableWidth;

  let handleSave = handleNotesSave;
  const editable_table_columns = table_columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave,
      }),
    };
  });

  const TransactionDrawerX = () => (
    <TransactionDrawer
      open={true}
      selectedTransaction={selectedTransaction}
      handleCounterpartyNameChange={handleCounterpartyNameChange}
      handleDateChange={handleDateChange}
      propertyName={props.propertyName}
      bankAccountName={props.bankAccountName}
      handleNotesChange={handleNotesChange}
      customCategories={props.customCategories}
      handleCustomCategoriesChange={handleCustomCategoriesChange}
      handleApproveEdits={handleApproveEdits}
      handleCounterpartyAssign={handleCounterpartyAssign}
      handleEditableFieldUpdate={handleEditableFieldUpdate}
      onTransactionUpdate={handleTransactionUpdate}
    />
  );

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      {/* Table Filters */}
      <TransactionTableFilters
        handleSearch={handleSearch}
        handleDateFilter={handleDateFilter}
        dateRangeFilter={dateRangeFilter}
        bankAccountName={props.bankAccountName}
        transactions={showCompletedTxns?.map((txn) => {
          return {
            ...txn,
            propertyName: props.propertyName,
            subportfolioName: props.portfolioName,
            bankAccountName: props.bankAccountDescription,
          }
        })}
        type="completed"
        handleTransactionsKindChange={handleTransactionsKindChange}
        transactionsKind={transactionsKind}
        needsReviewCount={needsReviewCount(completeTransactions)}
        bankAccountSource={props.apiSource}
        bankAccountId={props.bankAccountId}
        onRecalibrate={props.onRecalibrate}
      />

      {showPendingTable && props.apiSource == "UN" &&
        <TitledSection
          title="Processing"
          titleLevel={5}
          body={
            <GenericTableOnRowOnClick1
              pagination={{
                paginationModel: { pageSize: 5, page: 0 },
              }}
              sortModel={[
                {
                  field: "createdAt",
                  sort: "desc",
                },
              ]}
              pageSizeOptions={[5, 10, 25]}
              getRowId={(record) => record.id}
              columns={table_columns1}
              dataSource={showPendingTxns}
            />}
        />}

      {showPaymentRequests && props.apiSource != "UN" &&
        <TitledSection
          title="Processing"
          titleLevel={5}
          body={
            <GenericTableOnRowOnClick1
              pagination={{
                paginationModel: { pageSize: 5, page: 0 },
              }}
              sortModel={[
                {
                  field: "created_timestamp",
                  sort: "asc",
                },
              ]}
              pageSizeOptions={[5, 10, 25]}
              getRowId={(record) => record.id}
              columns={payment_request_columns}
              dataSource={paymentRequests}
              loading={props.loadingPaymentRequests}
            />}
        />}

      <TitledSection
        title={showPendingTable || showPaymentRequests ? "Complete" : undefined}
        titleLevel={5}
        body={
          <GenericTableOnRowOnClick1
            pagination={{
              paginationModel: { pageSize: showCompletedTxns?.length || 50, page: 0 },
            }}
            pageSizeOptions={[5, 10, 25, 50]}
            sortModel={[
              {
                field: "timestamp",
                sort: "desc",
              },
            ]}
            getRowId={(record) => record.id}
            columns={editable_table_columns}
            dataSource={showCompletedTxns}
            numerator={props.completeTransactionsNumerator}
            denominator={props.completeTransactionsDenominator}
            enableExpandable={true}
            handleExpand={handleExpand}
            transactionDrawerComponent={TransactionDrawerX}
            drawerWidth={"40%"}
            loading={props.loadingTransactions}
            {...(showLoadMore ? {
              footer: () => (
                <Box display="flex" justifyContent="center" mt={2}>
                  <Button
                    sx={{ fontSize: 14, textTransform: "none", width: '220px' }}
                    disableElevation
                    fullWidth
                    size="small"
                    type="submit"
                    variant="outlined"
                    color="secondary"
                    onClick={() => props.onLoadTransactions({ month: props.currentMonth, year: props.currentYear })}
                    disabled={props.transactionsLoading}
                  >
                    Load {props.currentMonth}/{props.currentYear} Transactions
                  </Button>
                </Box>
              )
            } : {
              footer: () => undefined
            })}
          />}
      />
      
      {showSplitPaymentModal && (
        <SplitPaymentModal
          selectedTransaction={selectedTransaction}
          showSplitPaymentModal={showSplitPaymentModal}
          closeSplitTransactionModal={closeSplitTransactionModal}
          showCompletedTxns={showCompletedTxns}
          updateCompletedTransactions={updateCompletedTransactions}
          completeTransactions={completeTransactions}
          canceledTransactions={props.canceledTransactions}
          bankAccountId={props.bankAccountId}
        />
      )}
    </Space>
  );
}

export default CompleteTransactions;